import Vue from "vue";
import Router from "vue-router";
import forgetPasw from "../view/forgetPasw.vue";
import home from "../view/home.vue";
import login from "../view/login.vue";
import modifyPasw from "../view/modifyPasw.vue";
import register from "../view/register.vue";
import shortLink from "../view/shortLink.vue";
import routerJson from "./router";
import external_routerJson from "./router_external";

import customPageHome from "../view/customPage/home.vue";
import externalHome from "../view/external/home.vue";
import protocolRegister from "../view/protocol/register.vue";
Vue.use(Router); 
const router = new Router({
  // mode: "history",
  routes: [
    {
      path: "/external",
      name: "externalHome",
      component: externalHome,
      children: [...external_routerJson],
    },
    {
      path: "/customPage",
      name: "customPageHome",
      component: customPageHome,
      children: [
        {
          path: "/customPage/paperGuarantee/guarantee",
          name: "customPagePaperGuaranteeGuarantee",
          component: () => import("@/view/customPage/paperGuarantee/guarantee.vue"),
        },
        {
          path: "/customPage/paperGuarantee/verify",
          name: "customPagePaperGuaranteeVerify",
          component: () => import("@/view/customPage/paperGuarantee/verify.vue"),
        },
        {
          path: "/customPage/home",
          name: "customPageHome",
          component: () => import("@/view/customPage/home.vue"),
        },
      ],
    },
    {
      path: "/login",
      name: "login",
      component: login,
    },
    //
    {
      path: "/register",
      name: "register",
      component: register,
    },
    {
      path: "/forgetPasw",
      name: "forgetPasw",
      component: forgetPasw,
    },
    {
      path: "/notify/detail",
      name: "notifyDetail",
      component: () => import("@/view/notify/detail.vue"),
    },
    {
      path: "/modifyPasw",
      name: "modifyPasw",
      component: modifyPasw,
    },
    {
      path: "/protocolRegister",
      name: "protocolRegister",
      component: protocolRegister,
    },
    //
    {
      path: "/s/:id",
      name: "shortLink",
      component: shortLink,
    },

    {
      path: "/",
      name: "home",
      component: home,
      children: [
        {
          path: "/",
          name: "index",
          component: () => import("@/view/index.vue"),
        },

        ...routerJson,
      ],
    },
    {
      path: "/404",
      name: "404",
      component: () => import("@/view/404.vue"),
    },
    {
      path: "*",
      redirect: {
        name: "404",
      },
    },
  ],
  scrollBehavior() {
    // return返回期望滚动到的位置的坐标
    return { x: 0, y: 0 }
  }
})
let NODE_ENV = process.config.env.NODE_ENV
router.beforeEach((to, from, next) => {
  let Nologin = ["login", "forgetPasw", "register", "protocol", "modifyPasw", "protocolRegister", 'applyCustoms', '404'];
  if (process.config.env && NODE_ENV == 'production' && process.config.env.SURE_ENTRY_API && window.location.origin.indexOf(process.config.env.SURE_ENTRY_API) == -1 && to.path.indexOf("/external") == -1 && to.path.indexOf("/404") == -1 && to.path.indexOf("/customs") == -1 && to.path.indexOf("/protocolRegister") == -1) {
    next({ name: "404" });
  } else if (NODE_ENV == 'production' && document.cookie.indexOf("baohan-jinfu-cust") == -1 && Nologin.indexOf(to.name) == -1 && to.path.indexOf("/external") == -1 && to.name.indexOf("shortLink") == -1 && (to.name.indexOf("applyCustoms") == -1 && !to.query.appid)) {
    Mirror.emit("tips_el_alert_box_close")
    if (to.path.indexOf('/loan/apply') > -1) {
      next({ name: "login", query: { type: 'loanApply' }  });
    } else {
       next({ name: "login"  });
    }
  } else if (to.fullPath.indexOf('?SSOLogin=1') != -1) {
    Mirror.emit("tips_el_alert_box_close")
    next({ replace: true });
  } else {
    Mirror.emit(['dg_form_dialog_close', 'tips_el_alert_box_close', 'el_form_dialog_close'])
    next();
  }


});

export default router;
